module.exports = __webpack_public_path__ + "img/qrCode.4f5da685.jpg";